import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentSalesOrder } from '@/providers/SalesOrderProvider';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { ScrollTop } from '@/components/element/ScrollTop';
import { useCurrentInvoiceTask } from '@/providers/InvoiceTaskProvider';
import { InvoiceTaskEditForm } from '@/components/features/tasks/invoice/[invoice_task_id]/InvoiceTaskEditForm';

export const BackofficeInvoiceTaskEdit = () => {
  const { _w_, _t_ } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  useEffect(() => setTitle(`請求タスク編集`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `請求タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/invoice_tasks` },
        {
          label: `請求タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/sales_orders/${_so_!.id}/invoice_tasks/${task!.id}`,
        },
      ]),
    []
  );

  const { _so_ } = useCurrentSalesOrder();
  const { invoiceTask: task } = useCurrentInvoiceTask();

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <InvoiceTaskEditForm />
    </WorkspaceLayout>
  );
};
